module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-btn c-main"
  }, [_c('button', {
    ref: "mybutton",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticClass: "btn_mask"
  }, [_c('div', {
    staticClass: "btn_loading"
  }, [_c('i', {
    class: _vm.loading_clazz
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c89ca12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = 511
// module chunks = 1